/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClaimClaimIdRisksPutRequestDto } from '../models/claim-claim-id-risks-put-request-dto';


/**
 * the ClaCommandCreateRisks API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaCommandCreateRisksService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation claimClaimIdRisksPut
   */
  static readonly ClaimClaimIdRisksPutPath = '/claim/{claimId}/risks';

  /**
   * Create or update a claim risks.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimClaimIdRisksPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  claimClaimIdRisksPut$Response(params: {
    claimId: string;
    body: ClaimClaimIdRisksPutRequestDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ClaCommandCreateRisksService.ClaimClaimIdRisksPutPath, 'put');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Create or update a claim risks.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimClaimIdRisksPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  claimClaimIdRisksPut(params: {
    claimId: string;
    body: ClaimClaimIdRisksPutRequestDto
  },
  context?: HttpContext

): Observable<void> {

    return this.claimClaimIdRisksPut$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
